import axios from 'axios'
import {LeadModel} from '../models/LeadModel'
import {LeadStatusModel} from '../../leadStatus/models/LeadStatusModel'

const API_URL = process.env.REACT_APP_API_URL

// Get leads by page
export function getLeadsByPage(subscriberId: string, requestedPage: number, agentId?: string) {
  const params: any = {
    'filter[limit]': 10,
    'filter[skip]': (requestedPage - 1) * 10,
    'filter[order]': 'created_on DESC',
    'filter[where][status]': 'lead',
  }

  // Add agent filter if specified
  if (agentId) {
    delete params['filter[where][status]']
    params['filter[where][and][0][status]'] = 'lead'
    params['filter[where][and][1][agentId]'] = agentId
  }

  return axios.get<LeadModel[]>(`${API_URL}/Subscribers/${subscriberId}/guests`, {
    params,
  })
}

// Update lead
export function updateLead(subscriberId: string, guestId: string, data: any) {
  return axios.put(`${API_URL}/Subscribers/${subscriberId}/guests/${guestId}`, data)
}

// Fetch lead statuses
export function getLeadStatuses(subscriberId: string) {
  return axios.get<LeadStatusModel[]>(`${API_URL}/Subscribers/${subscriberId}/leadStatuses`)
}

export function downloadCSV(subscriberId: string, from: number, to: number, access_token: string) {
  return axios.get(
    `${API_URL}/Subscribers/${subscriberId}/downloadCSV?from=${from}&to=${to}&access_token=${access_token}`
  )
}
